import _property from 'lodash/property';

var id = _property('id');

var name = _property('name');

var departmentCode = _property('extras.code.0');

var description = _property('extras.description.0');

var departmentType = _property('extras.department_type.0');

var isDefault = _property('extras.default.0');

var isInactive = _property('extras.inactive.0');

var READER = {
  id: id,
  name: name,
  departmentCode: departmentCode,
  description: description,
  departmentType: departmentType,
  isDefault: isDefault,
  isInactive: isInactive
};
export default READER;